<template>
  <div class="detail_information">
    <Flow v-bind:step="2"/>
    <Loading v-show="loading" />

    <div class="products_wrap bg_white mt12 pt16 pb16">

      <SectionTitle
        :title="'ご注文内容'"
        :width="''"
      />
      <div class="pl16 pr16 mt24">
        <SumContents
          :title="'商品合計'"
          :price="totalPrice"
          :symbol="'yen'"
        />
        <SumContents
          :title="'送料'"
          :price="shipmentFee"
          :symbol="'yen'"
        />
        <SumContents
          class="total_wrap"
          :title="'ご請求金額'"
          :price="billAmount"
          :symbol="'yen'"
        />
      </div>

    </div>

    <div class="products_wrap bg_white mt12 pt16 pb16">
      <!-- <div class="obi rb">STEP2</div> -->
      <SectionTitle
        :title="'ウォレットの利用'"
        :width="'160'"
      />
      <div class="pl16 pr16 mt16">
        <div class="balance">
          <div class="balance_wrap">
            <h4 class="balance_title rb">現在のウォレット残高</h4>
            <p class="balance_price rm"><span class="yen ab">￥</span>{{ cashAmount.toLocaleString() }}</p>
          </div>
          <div class="balance_wrap">
            <h4 class="balance_title rb">現在のお買い物ポイント</h4>
            <p class="balance_price rm">{{ pointAmount.toLocaleString() }} <span class="yen ab">P</span></p>
          </div>
        </div>

      </div>

      <div v-if="cashAmount > 0 || pointAmount > 0" class="mt16">
        <div class="pl16 pr16 pb10 bdb">
          <input id="wallet0" class="payment_radio" type="radio" name="wallet" @click="selectWallet('NO_USE')" :checked="selectWalletType == 'NO_USE'">
          <label for="wallet0" class="payment_contents rb" >ウォレットを使用しない</label>
        </div>
        <div class="pl16 pr16 pb10 mt16 bdb">
          <input id="wallet1" class="payment_radio" type="radio" name="wallet" @click="selectWallet('ALL_USE')" :checked="selectWalletType == 'ALL_USE'">
          <label for="wallet1" class="payment_contents rb" >ウォレットから支払う（全額）</label>
        </div>
        <div class="pl16 pr16 pb10 mt16 bdb mb20">
          <input id="wallet2" class="payment_radio" type="radio" name="wallet" @click="selectWallet('PART_USE')" :checked="selectWalletType == 'PART_USE'">
          <label for="wallet2" class="payment_contents rb" >ウォレットから支払う（一部）</label>
          <div v-if="selectWalletType == 'PART_USE'" class="input_wrap pl16 pr16">
            <input ref="walletInput" class="wallet_input" :type="isTyping ? 'number' : 'text'" @focus="changeTyping(true)" @blur="changeTyping(false)" v-model="inputWallet" placeholder="0" pattern="\d*">
            <!-- <p v-if="!isTyping" class="wallet_input" @click="changeTyping(true)">{{ purchaseWalletWalletAmount != null ? Number(purchaseWalletWalletAmount).toLocaleString() : 0 }}</p> -->
          </div>
        </div>

        <SumContents
          class="pl16 pr16"
          :title="'会計後のウォレット残高'"
          :price="leftOverCashAmount"
          :symbol="'yen'"
        />
        <SumContents
          class="pl16 pr16"
          :title="'会計後のお買い物ポイント'"
          :price="leftOverPointAmount"
          :symbol="'point'"
        />
      </div>

      <SectionTitle
      class="mt24"
        :title="'お支払い内訳'"
        :width="''"
      />
      <div class="pl16 pr16 mt24">
        <SumContents
          :title="'ご注文内容合計'"
          :price="billAmount"
          :symbol="'yen'"
        />
        <SumContents
          class="sum_coupon"
          :title="'ウォレット残高使用額'"
          :price="useWallet"
          :symbol="'yen'"
        />
        <SumContents
          class="sum_coupon"
          :title="'お買い物ポイント使用額'"
          :price="usePurchasePoint"
          :symbol="'point'"
        />
        <SumContents
          class="total_wrap"
          :title="'ウォレット使用後の請求金額'"
          :price="useWalletBillAmount"
          :symbol="'yen'"
        />
      </div>
    </div>
    <div class="products_wrap bg_white mt12 pt32 pb48">
      <a href="#" class="btn_blue" @click.stop.prevent="nextBtn()">次へ</a>
      <router-link class="btn_delete back_btn" :to="{ name: 'NSelectionSelectProducts' }">戻る</router-link>
    </div>

    <ErrorModal v-if="isErrorModal" :errorMessage="errorMessage" @modalClose="modalClose" />
  </div>
</template>

<script>
import Loading from '@/components/common/Loading';
import { mapGetters } from 'vuex';
import Purchases from '@/components/api/purchases';
import Flow from '@/components/n-selection/Flow'
import SectionTitle from '@/components/common/SectionTitle';
import SumContents from '@/components/purchase/SumContents';
import Wallet from '@/components/api/wallet/wallet';
import PurchaseModel from '@/model/purchase/purchaseWallet';

import NSelection from '@/components/api/n-selection/n-selection';
import ErrorModal from '@/components/common/ErrorModal';
import ProductFunction from '@/model/n-selection/selectProducts'


export default {
  components: {
    Flow,
    SectionTitle,
    SumContents,
    ErrorModal,
    Loading,
  },
  data() {
    return {
      isErrorModal: false,
      errorMessage: '',
      isTyping: false,
      inputType: 'number',
      loading: false,
      billAmount: 0,
      cashAmount: 0,
      pointAmount: 0,
      totalAmount: 0,

      leftOverPointAmount: 0,
      leftOverCashAmount: 0,
      useAmount: 0,

    }
  },
  methods: {
    calcUseWalletBillAmount() {
      this.$store.commit('nselection/setUseWalletBillAmount', this.billAmount - this.useWalletBillAmount)
      this.calcBalance();
    },
    changeTyping(bool) {
      if(bool) {
        // numberようにカンマを削除する
        this.$store.commit('nselection/setInputWallet', this.removeComma(this.inputWallet));
      }
      this.isTyping = bool;
      if(!this.isTyping) {
        // textに変更してから数値にカンマをつける
        this.$store.commit('nselection/setInputWallet', Number(this.inputWallet).toLocaleString());
      }
    },
    suppressZero1(str) {
      if(str != null && str != '') {
        return str.replace(/^0+/, '');
      }
    },
    removeComma(str) {
      let removed = String(str);
      if(removed.includes(',')) {
        removed = removed.replace(/,/g, '');
      }
      return parseInt(removed, 10);
    },
    calcUseAmount() {
      let amount = 0
      if(this.walletAmount == null || this.walletAmount == '' || this.selectWalletType == 'NO_USE') {
        amount =  0;
      } else {
        amount =  Number(this.walletAmount);
      }
      this.useAmount = amount;
      this.calcUseWalletBillAmount();
    },
    selectWallet(use) {
      this.$store.commit('nselection/setSelectWalletType', use);
      if(use == 'ALL_USE') {
        this.allIn();
      }
      if(use == 'PART_USE') {
        this.$store.commit('nselection/setWalletAmount', this.removeComma(this.inputWallet));
      }
      if(use == 'NO_USE') {
        this.$store.commit('nselection/setWalletAmount', 0);
      }
      // this.calcUseAmount();
      this.calcAmount();
    },
    modalClose() {
      this.isErrorModal = false;
    },
    nextBtn() {
      if(this.totalAmount < this.walletAmount) {
        this.isErrorModal = true;
        this.errorMessage = 'ウォレット使用額が現在の残高を超えています。';
        return;
      }
      if(this.billAmount - this.walletAmount < 0 ) {
        this.isErrorModal = true;
        this.errorMessage = 'ウォレット使用額がご請求金額を超えています。';
        return;
      }
      if(this.selectWalletType == 'NO_USE') {
        this.$store.commit('nselection/setWalletAmount', 0);
      }

      this.$router.push({ name: 'NSelectionSelectPaymentAndShipping' });
    },
    calcBalance() {
      let walletAmount = this.walletAmount == null ? 0 : this.walletAmount;
      this.balance = (this.cashAmount - walletAmount).toLocaleString();
    },
    calcAmount() {
      /*-------------------------------------
        お買い物ポイントから使用
        なくなったらウォレットのポイントを使用する
      --------------------------------------*/
      let cashAmount = this.cashAmount; // ウォレット
      let pointAmount = this.pointAmount; // お買い物ポイント
      let usePoint = this.walletAmount; // 使用するポイント

      if((pointAmount - usePoint) > 0) {
        // お買い物ポイントだけで支払える場合
        this.leftOverPointAmount = pointAmount - usePoint;
        this.leftOverCashAmount = cashAmount;
      } else {
        // お買い物ポイントだけで支払えない場合
        this.leftOverPointAmount = 0;
        usePoint = usePoint - pointAmount; // 残りをウォレットで支払い
        if((cashAmount - usePoint) > 0) {
          // ウォレットで残りを支払える場合
          this.leftOverCashAmount = cashAmount - usePoint;
        } else {
          // ウォレットで残りを支払えない場合
          this.leftOverCashAmount = 0;
        }
      }


      this.$store.commit('nselection/setUseWallet', this.cashAmount - this.leftOverCashAmount);
      this.$store.commit('nselection/setUsePurchasePoint', this.pointAmount - this.leftOverPointAmount);
      this.$store.commit('nselection/setUseWalletBillAmount', this.billAmount - this.walletAmount)
    },
    allIn() {
      let setPoint = 0;
      if(this.billAmount > this.totalAmount) {
        // 注文内容合計が保有しているポイントより多かった場合
        setPoint = this.totalAmount;
      } else {
        // 保有しているポイントが注文内容合計より多かった場合
        setPoint = this.billAmount;
      }
      this.$store.commit('nselection/setWalletAmount', setPoint); // 使用するポイント
      this.calcAmount();
    },
    async apiGetDiscountInfo() {
      console.log('getDiscountInfo リクエスト');
      let requestData = ProductFunction.deleteOrderZeroItem(this.requestData);
      console.log(requestData);
      await NSelection.getDiscountInfo(requestData).then((val) => {
        console.log('getDiscountInfo レスポンス');
        console.log(val);
        this.$store.commit('nselection/setShipmentFee', val.shipmentFee);
        this.billAmount = this.totalPrice + this.shipmentFee;

        if(val.productShipmentFeeList.length > 0) {
          for (var i = 0; i < val.productShipmentFeeList.length; i++) {
            let index = this.nselectionOrderList.findIndex(({productId}) => productId == val.productShipmentFeeList[i].productId);
            this.nselectionOrderList[index].shipmentFee = val.productShipmentFeeList[i].shipmentFee;
          }
        }
      });
    },
    async apiGetBalance() {
      await Wallet.getBalance().then((val) => {
        console.log('残高');
        console.log(val);
        this.cashAmount = val.cashAmount;
        this.pointAmount = val.pointAmount;
        this.totalAmount = val.totalAmount;
      });
    },
    initialized() {
      // this.totalPrice = 0;
      this.billAmount = 0;
      this.cashAmount = 0;
      this.pointAmount = 0;
      this.leftOverCashAmount = 0;
      this.leftOverPointAmount = 0;
      this.$store.commit('setSelectWalletType', 'NO_USE');
      this.$store.commit('setInputWallet', 0);
      this.$store.commit('nselection/setWalletAmount', 0);
      this.$store.commit('nselection/setShipmentFee', 0);
      this.$store.commit('nselection/setUseWalletBillAmount', 0);
      this.$store.commit('nselection/setUseWallet', 0);
      this.$store.commit('nselection/setUsePurchasePoint', 0);

      // this.$store.commit('setUserDetailCouponList', []);
    },

  },

  computed: {
    ...mapGetters(
      'nselection', [
        'nselectionOrderList',
        'requestData',
        'totalPrice',
        'useWallet',
        'walletAmount',
        'usePurchasePoint',
        'selectWalletType',
        'inputWallet',
        'shipmentFee',
        'useWalletBillAmount',
      ],
    ),
    inputWallet: {
      get() {
        if(this.isTyping) {
          return this.removeComma(this.$store.state.nselection.wallet.inputWallet);
        } else {
          return this.$store.state.nselection.wallet.inputWallet;
        }
      },
      set(val) {
        if(val != '' || val != null) {
          if(this.isTyping) {
            // 先頭の0を消す
            let num = Number(val) < 0 ? 0 : Number(val);
            this.$store.commit('nselection/setInputWallet', num);
            this.$store.commit('nselection/setWalletAmount', this.removeComma(num));
            this.calcAmount();
          }
        }
      }
    }
  },
  async created () {
    this.loading = true;
    this.initialized();
    await this.apiGetDiscountInfo();
    await this.apiGetBalance();
    this.calcUseWalletBillAmount();
    this.selectWallet(this.selectWalletType);
    this.calcAmount();

    this.loading = false;
  },
}
</script>

<style lang="css" scoped>
.total_wrap {
  border-top: 1px solid #C9C9C9;
  padding-top: 13px;
}

.wallet_input {
  border: none;
  border-bottom: 1px solid #c9c9c9;
  color: #5a5a5a;
  font-family: 'Roboto';
  font-weight: 700;
  font-size: 26px;
  margin-top: 5px;
  padding-bottom: 5px;
  text-align: center;
  width: 100%;
}

/* .btn_wrap {
  margin-top: 8px;
  width: 37%;
} */

.balance {
  display: flex;
  justify-content: center;
}
.balance_wrap {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 48%;
}

.balance_title {
  font-size: 14px;
}

.balance_price {
  font-size: 20px;
}

.input_wrap {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.input_wrap .yen {
  font-size: 22px;
}

.obi {
  background-color: #4FCCD4;
  color: #fff;
  font-size: 18px;
  margin-bottom: 16px;
  padding: 8px;
  text-align: center;
  width: 100%;
}

.birth_text {
  color: blue;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 0 16px;
}

.coupon_wrap {
  margin-bottom: 16px;
}

.caution_text {
  font-size: 13px;
  margin-bottom: 16px;
}

.no_coupon {
  margin-bottom: 24px;
  padding-bottom: 5px;
}

.coupon_title {
  border-left: 4px solid  #4FCCD4;
  font-size: 16px;
  padding-left: 4px;
}

.coupon_item {
  align-items: flex-end;
  display: flex;
  margin-top: 8px;
}
.possession_coupon {
  display: flex;
  width: 68%;
}

.possession_count, .can_count {
  font-size: 12px;
}
.possession_count--number, .can_count--number {
  font-size: 18px;
  margin-left: 9px;
}

.can_count {
  margin-left: 26px;
}

.use_wrap {
  align-items: center;
  display: flex;
  margin-left: 8px;
  width: 30%;
}
.use_text {
  font-size: 12px;
  min-width: 40px;
}

.coupon_select--wrap {
  width: 60%;
}

.coupon_select {
  border: none;
  border-bottom: 1px solid  #5a5a5a;
  font-size: 26px;
  padding-left: 15px;
  width: 100%;
}
.bottom_arrow::after {
  bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/views/n-selection/Discount.vue